export enum ConditionContextMenuOptions {
  Delete = "delete",
  Export = "export",
  Unlink = "unlink"
}
